import { React, useState, useEffect } from 'react';
import { Container, Row } from 'react-bootstrap';
import { EquipmentsSearcher } from './EquipmentsSearcher/EquipmentsSearcher';
import { EquipmentTypeSelector } from './EquipmentTypeSelector/EquipmentTypeSelector';
import { DwellingPhoneUpdater } from './PhoneUpdater/DwellingPhoneUpdater'; 
import { ResidentPhoneUpdater } from './PhoneUpdater/ResidentPhoneUpdater';
import { EquipmentDetails } from './EquipmentDetails/EquipmentDetails';
import { MobileDeviceSelector } from './MobileDeviceSelector/MobileDeviceSelector';
import { useTranslation } from 'react-i18next';
import * as api from 'services/api';

export function Home() {
    const { t } = useTranslation();
    const [interventionTypes, setInterventionTypes] = useState([]);
    const [interventionType, setInterventionType] = useState({
        mobileDevice: false,
        updatePhone: false,
        id: 0,
        name: '',
        text: '',
        integrationId: 0,
        enable: false,
        checkLocation: false,
        deletePhone: false,
        selectedPhone: 0,
        controlDigitsNumber: 0
    });
    const [newPhoneNumber, setNewPhoneNumber] = useState('');
    const [equipmentData, setEquipmentData] = useState({
    equipmentIdent: '',
    epecLocationId: '',
    equipmentTelephone: '',
    otherTelephone: '',
    telephone3: ''
    });
    const [equipmentIdentDisabled, setEquipmentIdentDisabled] = useState();
    const [equipmentFound, setEquipmentFound] = useState(null);
    const [showDetails, setShowDetails] = useState();
    const [cleanButt, setCleanButt] = useState(false);

    useEffect(() => {
        getInterventionTypes();
    }, []);

    const getInterventionTypes = async () => {
        const response = await api.getInterventionTypes();

        if (response.status === 200) {
            const enabledTypes = response.data.filter(type => type.enable === true);
            setInterventionTypes(enabledTypes);
        } else {
            console.error('Error al obtener el listado de tipos de intervenci�n');
        }
    };  

    useEffect(() => {
        if (interventionTypes.length === 1) setInterventionType(interventionTypes[0]);
    }, [interventionTypes]);

    useEffect(() => {
        if (interventionType) {
            if (interventionType.mobileDevice === false && interventionType.updatePhone === false) setShowDetails(true);
            if (interventionType.updatePhone === true) setShowDetails(false);
            if (interventionType.mobileDevice === true) setShowDetails(false);
        }
        setNewPhoneNumber('');
    }, [interventionType]);

    return (
        <div className="page-content">
            <Container style={{ maxWidth: '570px' }}>
                <h2 className="mt-4">{t('deviceManagement')}</h2>
                <Row>
                    <EquipmentsSearcher
                        equipmentData={equipmentData}
                        setEquipmentData={setEquipmentData}
                        equipmentIdentDisabled={equipmentIdentDisabled}
                        setEquipmentIdentDisabled={setEquipmentIdentDisabled}
                        equipmentFound={equipmentFound}
                        setEquipmentFound={setEquipmentFound}
                        disableCleanButt={cleanButt}
                        setInterventionType={setInterventionType}
                    />
                </Row>

                {equipmentFound && (
                    <div>
                        <h5>{t('deviceNumber')}: <b>{equipmentData.equipmentIdent}</b></h5>
                        {interventionTypes.length > 1 && (
                            <EquipmentTypeSelector interventionTypes={interventionTypes} setInterventionType={setInterventionType}/>
                        )}


                        {interventionType?.id > 0 && (
                            <>
                                {interventionType.updatePhone && (
                                    interventionType.mobileDevice === false ? (
                                        <DwellingPhoneUpdater
                                            equipmentData={equipmentData}
                                            setEquipmentData={setEquipmentData}
                                            setShowDetails={setShowDetails}
                                            interventionType={interventionType}
                                        />
                                    ) : (
                                        <ResidentPhoneUpdater
                                            equipmentData={equipmentData}
                                            setNewPhoneNumber={setNewPhoneNumber}
                                            newPhoneNumber={newPhoneNumber}
                                            setShowDetails={setShowDetails}
                                            interventionType={interventionType}
                                        />
                                    )
                                )}

                                {!interventionType.updatePhone && interventionType.mobileDevice && (
                                    <MobileDeviceSelector
                                        equipmentData={equipmentData}
                                        setNewPhoneNumber={setNewPhoneNumber}
                                        setShowDetails={setShowDetails}
                                    />
                                )}

                                {showDetails && (
                                    <EquipmentDetails
                                        equipmentData={equipmentData}
                                        setDisableCleanButt={setCleanButt}
                                        interventionType={interventionType}
                                        newPhoneNumber={newPhoneNumber}
                                    />
                                )}
                            </>
                        )}

                    </div>
                )}
            </Container>
        </div>
    );
}
